export default __webpack_public_path__ + "static/media/05_Livingroom-Interior-Architecture-EschweilerPhotography_M1A9690.21523db8.jpg";